import React, { useState } from 'react';
import ingredientsData from './nutriData.json';
import IngredientForm from './IngredientForm';
import NutrientTable from './NutrientTable';
import NutrientPieChart from './NutrientPieChart';
import './Nutri.css';
import { Link } from 'react-router-dom';

import NeutriFacts from './NeutriFacts';

const NutriLore = () => {
  const [selectedIngredients, setSelectedIngredients] = useState([]);

  const handleUpdate = (ingredients) => {
    setSelectedIngredients(ingredients);
  };

const calculateTotals = () => {
  const totals = {
    GI: 0,   // ✅ Will sum constant GI values
    GL: 0,   // ✅ Will calculate based on scaled carbs
    calories: 0,
    fat: 0,
    fiber: 0,
    carbohydrates: 0,
    protein: 0,
    water: 0,
    vitaminC: 0,
    vitaminA: 0,
    calcium: 0,
    iron: 0,
    potassium: 0,
    magnesium: 0,
    zinc: 0,
    phosphorus: 0,
    selenium: 0
  };

  selectedIngredients.forEach(({ name, grams }) => {
    const data = ingredientsData.find(i => i.name === name);
    if (data) {
      Object.keys(totals).forEach(key => {
        if (key === 'GL' || key === 'GI') return; // Skip GL and GI here
        let value = 0;
        if (key.startsWith('vitamin')) {
          value = data.nutrients.vitamins?.[key] || 0;
        } else if (
          ['calcium', 'iron', 'potassium', 'magnesium', 'zinc', 'phosphorus', 'selenium'].includes(key)
        ) {
          value = data.nutrients.minerals?.[key] || 0;
        } else {
          value = data.nutrients?.[key] || 0;
        }
        totals[key] += value * grams / 100;
      });

      // ✅ GL calculation
      const GI = data.nutrients?.GI || 0;
      const carbs = data.nutrients?.carbohydrates || 0;
      totals.GL += (GI * carbs * grams) / 10000;

      // ✅ GI summing (unscaled)
      totals.GI += GI;
    }
  });

  return totals;
};





  const totals = calculateTotals();

  return (
    <div className="app-container">
       
      <h1>Nutrilore 🌿</h1>
      <IngredientForm ingredientsData={ingredientsData} onUpdate={handleUpdate} />
      <NutrientTable selected={selectedIngredients} ingredientsData={ingredientsData} totals={totals} />
      <NutrientPieChart totals={totals} />
      
    </div>
  );
};

export default NutriLore;
